export enum ProductsTab {
  Products = 'products',
  Packages = 'packages',
  Addons = 'addons',
  Tools = 'tools',
}
